export enum INSTANCE {
    /**
     * @value Site favicon
     */
    FAVICON = 'ADMIN_INSTANCE_SETTINGS_FAVICON',
    /**
     * @value No favorites
     * @description Message displayed when a directory has no entries
     */
    FAVORITES_NO_ENTRIES = 'FRONT.FAVORITES.NO_ENTRIES',
    /**
     * @value Sites management
     */
    INSTANCES = 'ADMIN.NAV.INSTANCES',
    /**
     * @value Sites
     */
    INSTANCES_TITLE = 'ADMIN.NAV.INSTANCES.TITLE',
    /**
     * @value Site settings
     */
    INSTANCE_SETTINGS = 'ADMIN.NAV.INSTANCE_SETTINGS',
    /**
     * @value Site logo
     */
    LOGO = 'ADMIN_INSTANCE_SETTINGS_LOGO',
    /**
     * @value Sites management
     */
    MANAGEMENT = 'ADMIN.NAV.INSTANCES.MANAGEMENT',
    /**
     * @value Upload favicon
     */
    UPLOAD_FAVICON = 'ADMIN_INSTANCE_SETTINGS_FAVICON_UPLOAD',
    /**
     * @value Upload logo
     */
    UPLOAD_LOGO = 'ADMIN_INSTANCE_SETTINGS_LOGO_UPLOAD',
}
